import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import templateHtml from 'templates/main/AlertMessagesView.html';

var Events = {
    ON_MESSAGE_CLOSED: 'ON_MESSAGE_CLOSED'
};

var AlertMessagesView = Backbone.View.extend({
    template: _.template(templateHtml),

    attributes: function() {
        return {
            class: 'page-message-container'
        };
    },

    events: {
        'click .notification-dismiss': 'onGrowlNotificationDismissed',
        'click button': 'onClose'
    },

    initialize: function(args) {
        this.pageViewSuccessMessage = args.pageViewSuccessMessage;
        this.pageViewFailureMessage = args.pageViewFailureMessage;
        this.pageViewInfoMessage = args.pageViewInfoMessage;
        this.growl = args.growl;

        if (this.growl) {
            this.$el.addClass('growl-alert alert-growl-bottom-right');
        }

        return this;
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                pageViewSuccessMessage: this.pageViewSuccessMessage,
                pageViewFailureMessage: this.pageViewFailureMessage,
                pageViewInfoMessage: this.pageViewInfoMessage,
                growl: this.growl
            })
        );

        this.$errorElement = this.$('.alert-error');
        this.$errorElementText = this.$errorElement.find('.alert-text');
        this.$successElement = this.$('.alert-success');
        this.$successElementText = this.$successElement.find('.alert-text');
        this.$infoElement = this.$('.alert-info');
        this.$infoElementText = this.$infoElement.find('.alert-text');

        return this;
    },

    updateSuccessMessage: function(message) {
        //updates text only
        if (message || message === '') {
            this.pageViewSuccessMessage = message;
        }

        this.$successElementText.text(this.pageViewSuccessMessage);
    },

    showSuccessMessage: function(message) {
        //if message, update then show
        this.updateSuccessMessage(message);
        this.$successElement.show();
    },

    hideSuccessMessage: function(clearText) {
        if (clearText) {
            this.$successElementText.empty();
        }

        this.$successElement.hide();
    },

    updateFailureMessage: function(message) {
        //updates text only
        if (message || message === '') {
            this.pageViewFailureMessage = message;
        }

        this.$errorElementText.text(message);
    },

    showFailureMessage: function(message) {
        //if message, update then show
        this.updateFailureMessage(message);
        this.$errorElement.show();
    },

    hideFailureMessage: function(clearText) {
        if (clearText) {
            this.$errorElementText.empty();
        }

        this.$errorElement.hide();
    },

    updateInfoMessage: function(message) {
        //updates text only
        if (message || message === '') {
            this.pageViewInfoMessage = message;
        }

        this.$infoElementText.html(message);
    },

    showInfoMessage: function(message) {
        //if message, update then show
        this.updateInfoMessage(message);
        this.$infoElement.show();
    },

    hideInfoMessage: function(clearText) {
        if (clearText) {
            this.$infoElementText.empty();
        }

        this.$infoElement.hide();
    },

    onGrowlNotificationDismissed: function(e) {
        e.preventDefault();

        var $el = $(e.currentTarget).closest('.alert');

        $el.addClass('animated fadeOutRight');

        // perform regular removal after fade out animation ends
        setTimeout(
            function() {
                this.hideFailureMessage();
                this.hideSuccessMessage();
                $el.removeClass('animated fadeOutRight');
            }.bind(this),
            600
        );
    },

    onClose: function(e) {
        e.preventDefault();

        this.hideInfoMessage();

        this.trigger(Events.ON_MESSAGE_CLOSED);
    }
});

AlertMessagesView.Events = Events;

export default AlertMessagesView;
